<div class="modal-alert">
  {{firma.mensaje}}
</div>
